import { connect } from 'react-redux'
import { startLoop } from '../../Utils/Loop'
const FPSMeter = require('./fpsMeter')

 @connect(state => ({ hideFPSmeter: state.base.hideFPSmeter }))
export default class Meter extends React.Component {

  componentDidMount() {
    this.meter = new FPSMeter(this.element, { theme: "transparent", heat: true, graph: true })

    startLoop(this.meter.tick)
  }

  render() {
    const { hideFPSmeter } = this.props
    return (
    <div
      id="fps-meter"
      ref={e => this.element = e}
      style={{
          height: '50px',
          position: 'fixed',
          bottom: 0,
          display: hideFPSmeter ? 'none' : 'block'
      }}
    />
    )
  }
}
